import { Rating } from '@mui/material';
import { FC } from 'react';

import { ICatalogItem } from '../../../../shared/types/card';
import AddedToBasketButton from '../../../../ui/card/AddedToBasketButton/AddedToBasketButton';
import FavoriteButton from '../../../../ui/card/FavoriteButton/FavoriteButton';
import QuantityButton from '../../../../ui/card/QuantityButton/QuantityButton';
import Heading from '../../../../ui/heading/Heading';
import { CustomButton } from '../../../Button';
import { Icon } from '../../../Icon';
import CardGallery from '../CardGallery/CardGallery';

import styles from './CardInteraction.module.sass';
import { useCardInteraction } from './useCardInteraction';

interface ICardInteraction {
  item: ICatalogItem;
  activeImageIndex: number;
  handleSetActiveImageIndex: (num: number) => void;
}

const CardInteraction: FC<ICardInteraction> = ({
  item,
  activeImageIndex,
  handleSetActiveImageIndex,
}) => {
  const { cardInteraction, actions } = useCardInteraction();
  
  return (
    <div className={styles.interaction}>
      {cardInteraction.mobileScreen && (
        <CardGallery
          item={item}
          activeImage={activeImageIndex}
          setActiveImage={handleSetActiveImageIndex}
        />
      )}
      {cardInteraction.mobileScreen && (
        <Heading className={styles.title} title={item.title} />
      )}
      <div className={styles.top}>
        <p>Код товара: {item?.id}</p>
        <Icon variant="share" />
      </div>
      <div className={styles.center}>
        <h1 className={styles.price}>{item?.price_kopecks / 100} ₽</h1>
        <div className={styles.buttons}>
          <FavoriteButton item={item} text />
          <CustomButton variant="outlined" onClick={actions.handleScroll}>
            <>
              <Rating
                size="large"
                readOnly
                defaultValue={0}
                value={cardInteraction.countStars}
              />{' '}
              {cardInteraction.countReviews}
            </>
          </CustomButton>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.wrapper}>
          {cardInteraction.isAvailability ? (
            <AddedToBasketButton
              item={item}
              text
              isItemExistBasket={cardInteraction.isItemExistBasket}
              addToCart={actions.addToCart}
            />
          ) : (
            <CustomButton variant="outlined" className="disabled">
              <Icon variant="notifyGray" />
              <p>Уведомить</p>
            </CustomButton>
          )}

          {cardInteraction.isItemExistBasket ? (
            <QuantityButton item={item} />
          ) : null}
        </div>
        <div className={styles.check}>
          <Icon
            variant={
              cardInteraction.isAvailability ? 'checkCircle' : 'notAvailable'
            }
          />
          <div className={styles.text}>
            {cardInteraction.isAvailability ? 'В наличии' : 'Нет в наличии'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardInteraction;
